import { component, computed } from 'knockout-decorators'
import type { Offer } from '@tixa/schema'
import { Language } from '~/utils/language'

import source from './item.html?raw'
import { CartState } from '../state'

@component('cart-item', source)
export class CartItem {
  private cartState = CartState.get()
  private Locale = Language.getInstance()

  constructor(private params: { offer: Offer }) {}

  @computed private get offer(): Offer | undefined {
    return this.cartState.offers.find((offer) => {
      const idMatch = offer['@id'] === this.params.offer['@id']
      const seatMatch = offer.seatmapSeatId
        ? offer.seatmapSeatId === this.params.offer.seatmapSeatId
        : true
      const standMatch = offer.seatmapStandingId
        ? offer.seatmapStandingId === this.params.offer.seatmapStandingId
        : true
      return idMatch && seatMatch && standMatch
    })
  }

  @computed get name(): string {
    const name = this.offer ? this.offer.name : ''
    if (this.Locale.language === 'en') {
      const translations = {
        Kedvezmény: this.Locale.translations.discount,
        'Kezelési költség': this.Locale.translations.handlingfee,
      }

      if (translations[name]) {
        return translations[name]
      }
    }
    return name
  }

  @computed get category(): string {
    return this.offer ? this.offer.category : ''
  }

  @computed get description(): string {
    return this.offer && this.offer.description ? this.offer.description : ''
  }

  @computed get hasDescription(): boolean {
    return this.offer ? this.description.length > 0 : false
  }

  @computed get price() {
    const price =
      this.offer && this.offer.price !== 0
        ? Language.formatCurrency(this.offer.price, this.offer.priceCurrency)
        : Language.getInstance().translations.free
    return price
  }

  @computed get totalPrice() {
    const value =
      typeof this.offer?.eligibleQuantity.value === 'string'
        ? Number.parseInt(this.offer.eligibleQuantity.value)
        : this.offer?.eligibleQuantity.value

    const price = this.offer ? this.offer.price * (value ?? 0) : 0
    const currency = this.offer ? this.offer.priceCurrency : 'HUF'
    return Language.formatCurrency(price, currency)
  }

  @computed get eligibleQuantity(): number {
    const eligibleQuantity =
      this.offer && this.offer.eligibleQuantity.value !== 0
        ? this.offer.eligibleQuantity.value
        : 0
    return eligibleQuantity
  }

  @computed get isTicket() {
    return this.offer ? this.offer.category === 'ticket' : false
  }

  @computed get quantity() {
    const value =
      typeof this.offer?.eligibleQuantity.value === 'string'
        ? Number.parseInt(this.offer.eligibleQuantity.value)
        : this.offer?.eligibleQuantity.value

    return this.offer ? Language.formatQuantity(value ?? 0) : 0
  }

  @computed get checkboxId() {
    return this.offer ? 'optionalCheck' + this.offer.sku : ''
  }

  @computed get isPaid() {
    return this.offer ? this.offer.price > 0 : 0
  }

  @computed get isOptional() {
    const minValue =
      typeof this.offer?.eligibleQuantity.minValue === 'string'
        ? Number.parseInt(this.offer.eligibleQuantity.minValue)
        : this.offer?.eligibleQuantity.minValue
    return minValue === 0
  }

  @computed get isChosen() {
    return this.offer
      ? this.cartState.chosenOptionalOffers.includes(this.params.offer['@id'])
      : false
  }
  set isChosen(chosen) {
    if (chosen) {
      this.cartState.chosenOptionalOffers = [
        ...this.cartState.chosenOptionalOffers,
        this.params.offer['@id'],
      ]
    } else {
      this.cartState.chosenOptionalOffers =
        this.cartState.chosenOptionalOffers.filter(
          (id) => id !== this.params.offer['@id']
        )
    }
  }
}
